<template>
  <ExpandCard
    ref="stats_expand_card"
    :persistKey="'card-trainer-stats'"
    tour="tra_live_stats"
    :icon="'mdi-poll'"
    :closed="closed"
    :title="$t('practice.stats.title')"
    :closedTooltip="$t('practice.stats.title')"
    style="--content-padding: 0.75rem; --radius-open: 4px"
    :canClose="canClose"
  >
    <TrainerStats :stats="stats" />
  </ExpandCard>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import TrainerStats from '@/components/Trainer/TrainerStats'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'

export default {
  name: 'TrainerStatsExpand',

  components: {
    TrainerStats,
    ExpandCard,
  },
  mixins: [format_mix],
  props: {
    stats: Object,
    closed: Boolean,
    canClose: { type: Boolean, default: true },
  },
  data() {
    return {}
  },
}
</script>
